import React from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { FaUser, FaEnvelope, FaPhone, FaWallet, FaHistory, FaEdit, FaMoneyBillWave, FaInfoCircle, FaCalendarAlt, FaArrowUp, FaArrowDown, FaRupeeSign, FaRegCalendarAlt } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import './Wallet.css';

// Custom styles for the modal
const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        maxWidth: '90%',
        width: '600px',
        padding: 0,
        border: 'none',
        borderRadius: '15px',
        background: 'transparent'
    }
};

const Viewwallet = () => {
    const {id} = useParams();
    const stateData = useLocation().state?.amount;
    const [user, setUser] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState({
        balance: '',
        transactionType: 'credit',
        message: '',
        expiryDate: ''
    });
    const [pageinationdata, setPaginationdata] = useState({
        total: 0,
        totalPages: 0,
        startItem: 0,
        endItem: 0,
        hasPrevPage: false,
        hasNextPage: false
    });
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const navigate = useNavigate();
    
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleEditClick = (transaction) => {
        setSelectedTransaction(transaction);
        setEditData({
            balance: transaction.balance,
            transactionType: transaction.transactionType,
            message: transaction.message,
            expiryDate: moment(transaction.expiryDate).format('YYYY-MM-DD')
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTransaction(null);
        setEditData({
            balance: '',
            transactionType: 'credit',
            message: '',
            expiryDate: ''
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

            const raw = JSON.stringify({
                balance: Number(editData.balance),
                transactionType: editData.transactionType,
                message: editData.message,
                expiryDate: editData.expiryDate === "Invalid date" ? undefined : editData.expiryDate
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(`https://api.experts4u.in/api/v2/Wallet/UpdateWallet/${selectedTransaction._id}`, requestOptions);
            const result = await response.json();
            
            if (result.success) {
                Swal.fire({
                    icon: 'success',
                    title: result.message,
                    showConfirmButton: false,
                    timer: 1500
                });
                handleCloseModal();
                getUser(id); // Refresh the data
            } else {
                Swal.fire({
                    icon: 'error',
                    title: result.message,
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong',
                showConfirmButton: false,
                timer: 1500
            });
        }
    };
    
    const getUser = async (id) => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

            const raw = JSON.stringify({
                "userId": id,
                "page": page,
                "limit": limit
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://api.experts4u.in/api/v2/Wallet/GetUserByAllTransaction", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    console.log(result);
                    setUser(result?.data);
                    if (result?.data?.length > 0) {
                        setUserInfo(result.data[0].userId);
                    }
                    if(result?.pagination) {
                        setPaginationdata({
                            total: result.pagination.total || 0,
                            totalPages: result.pagination.totalPages || 0,
                            startItem: ((page - 1) * limit) + 1,
                            endItem: Math.min(page * limit, result.pagination.total || 0),
                            hasPrevPage: page > 1,
                            hasNextPage: page < (result.pagination.totalPages || 1)
                        });
                    }
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.log(error);
        }
    }

    const handleJobClick = (jobId) => {
        window.open(`/jobDetails/${jobId}`, '_blank');
    };

    const renderMessage = (message) => {
        if (!message) return null;
        
        // Check if message contains job ID pattern
        const jobIdMatch = message.match(/Job created \((\d+)\)/);
        if (jobIdMatch) {
            const jobId = jobIdMatch[1];
            return (
                <span 
                    className="text-truncate" 
                    style={{ cursor: 'pointer', color: '#4e73df' }}
                    onClick={() => handleJobClick(jobId)}
                >
                    {message}
                </span>
            );
        }
        
        return <span className="text-truncate">{message}</span>;
    };

    useEffect(() => {
        getUser(id);
    }, [id, page, limit]);

    return (
        <div className="container-fluid py-3 py-md-5 mt-2 mt-md-4 wwwwwww">
            <div className="row justify-content-center">
                <div className="col-12 col-md-11">
                    {/* User Info Card */}
                    {userInfo && (
                        <div className="card mb-3 mb-md-4 border-0 shadow-sm">
                            <div className="card-body p-3 p-md-4">
                                <div className="row g-3">
                                    <div className="col-12 col-md-10">
                                        <div className="p-2 p-md-3 bg-white rounded">
                                            <div className="d-flex gap-3">
                                                <h6 className="mb-1 text-dark">Name : </h6>
                                                <h6 className="mb-0 mx-2 wwwtest">{userInfo.name?.charAt(0).toUpperCase() + userInfo.name?.slice(1).toLowerCase()}</h6>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <h6 className="mb-1 text-dark">Email : </h6>
                                                <h6 className="mb-0 mx-2 wwwtest">{userInfo.email}</h6>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <h6 className="mb-1 text-dark">Phone : </h6>
                                                <h6 className="mb-0 mx-2 wwwtest">{userInfo.mobileNo}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <div className="d-flex flex-column align-items-center justify-content-center h-100 p-3 bg-white rounded">
                                            <h6 className="mb-2 text-dark">Wallet Balance</h6>
                                            <h5 className="mb-0 text-success">
                                                {stateData}
                                            </h5>
                                        </div>
                                        </div>
                                
                                </div>
                            </div>
                        </div>
                    )}

             
                    {/* Transactions Table */}
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-0 py-2 py-md-3" style={{ borderRadius: '15px 15px 0 0' }}>
                            <div className="d-flex align-items-center">
                                <div className="icon-circle me-2 me-md-3" style={{
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <FaHistory className="text-white" size={16} />
                                </div>
                                <h5 className="mb-0 text-dark h6 h5-md">Transaction History</h5>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead style={{ 
                                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                        borderBottom: '2px solid #dee2e6'
                                    }}>
                                        <tr className="text-center">
                                            <th className="py-3 small align-middle">Sr.No</th>
                                            <th className="py-3 small align-middle">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                   <span className='pr-1'> <FaRupeeSign size={14} /></span>
                                                    <span>Amount</span>
                                                </div>
                                            </th>
                                            <th className="py-3 small align-middle">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                   <span className='pr-1'>                                                    <FaWallet size={14} />
                                                   </span>
                                                    <span>Type</span>
                                                </div>
                                            </th>
                                            <th className="py-3 small align-middle d-none d-md-table-cell">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span className='pr-1'>                                                    <FaCalendarAlt size={14} />
                                                    </span>
                                                    <span>Expiry Date</span>
                                                </div>
                                            </th>
                                            <th className="py-3 small align-middle d-none d-md-table-cell">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span className='pr-1'>                                                    <FaInfoCircle size={14} />
                                                    </span>
                                                    <span>Message</span>
                                                </div>
                                            </th>
                                            <th className="py-3 small align-middle d-none d-md-table-cell">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span className='pr-1'>                                                    <FaInfoCircle size={14} />
                                                    </span>
                                                    <span>SP Message</span>
                                                </div>
                                            </th>
                                            <th className="py-3 small align-middle d-none d-md-table-cell">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <span className='pr-1'>
                                                        <FaRegCalendarAlt size={14} />
                                                    </span>
                                                    <span>Created Date</span>
                                                </div>
                                            </th>
                                            <th className="py-3 small align-middle">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {user?.map((item, index) => (
                                            <tr className="text-center align-middle" key={index} style={{ 
                                                borderBottom: '1px solid #f0f0f0',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                <td className="py-3 small">{index + 1}</td>
                                                <td className="py-3">
                                                    <div className="d-inline-flex align-items-center justify-content-center">
                                                        <span className={`badge px-3 py-2 text-white d-inline-flex align-items-center gap-1 ${item?.transactionType === "credit" ? "bg-success bg-gradient" : "bg-danger bg-gradient"}`}
                                                            style={{
                                                                fontSize: '0.85rem',
                                                                fontWeight: '500'
                                                            }}>
                                                            <FaRupeeSign size={12} style={{ marginTop: '-2px' }} />
                                                            <span className='ms-2'>{item?.balance}</span>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="py-3">
                                                    <div className="d-inline-flex align-items-center justify-content-center">
                                                        <span className={`badge px-3 py-2 d-inline-flex align-items-center gap-2 ${item?.transactionType === "credit" ? "bg-success bg-gradient" : "bg-danger bg-gradient"}`}
                                                            style={{
                                                                fontSize: '0.85rem',
                                                                fontWeight: '500'
                                                            }}>
                                                            {item?.transactionType === "credit" ? (
                                                                <>
                                                                   <span className='pr-2'> <FaArrowUp color='white' size={12} style={{ marginTop: '-2px' }} /></span>
                                                                    <span className='text-white ms-2'>Credit</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                   <span className='pr-2'> <FaArrowDown color='white' size={12} style={{ marginTop: '-2px' }} /></span>
                                                                    <span className='text-white'>Debit</span>
                                                                </>
                                                            )}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="py-3 small d-none d-md-table-cell">
                                                    {moment(item?.expiryDate).isValid() ? (
                                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                                            <span className='pr-1'>
                                                                <FaCalendarAlt 
                                                                    className={moment(item?.expiryDate).isBefore(moment(), 'day') ? 'text-danger' : 'text-muted'} 
                                                                    size={14} 
                                                                    style={{ marginTop: '-2px' }} 
                                                                />
                                                            </span>
                                                            <span className={moment(item?.expiryDate).isBefore(moment(), 'day') ? 'text-danger' : ''}>
                                                                {moment(item?.expiryDate).format("DD-MM-YYYY")}
                                                            </span>
                                                        </div>
                                                    ) : null}
                                                    {moment(item?.expiryDate).isBefore(moment(), 'day') && (
                                                        <span className="ms-2 text-danger">Expired</span>
                                                    )}
                                                </td>
                                                <td className="py-3 small d-none d-md-table-cell">
                                                    <div className="d-flex align-items-center justify-content-center gap-2 text-truncate px-2">
                                                        <span className='pr-1'>
                                                            <FaInfoCircle className="text-muted flex-shrink-0" size={14} style={{ marginTop: '-2px' }} />
                                                        </span>
                                                        {renderMessage(item?.message)}
                                                    </div>
                                                </td>
                                                
                                                <td className="py-3 small d-none d-md-table-cell" style={{visibility: item?.Spmesage ? 'visible' : 'hidden'}}>
                                                    <div className="d-flex align-items-center justify-content-center gap-2 text-truncate px-2">
                                                        <span className='pr-1'>
                                                            <FaInfoCircle className="text-muted flex-shrink-0" size={14} style={{ marginTop: '-2px' }} />
                                                        </span>
                                                        {renderMessage(item?.Spmesage)}
                                                    </div>
                                                </td>
                                                <td className="py-3 small d-none d-md-table-cell justify-content-center ">
                                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                                            <span className='pr-1'>
                                                                <FaCalendarAlt 
                                                                    className="text-muted"
                                                                    size={14} 
                                                                    style={{ marginTop: '-2px' }} 
                                                                />
                                                            </span>
                                                            <span>
                                                                {moment(item?.createdAt).format("DD-MM-YYYY")}
                                                            </span>
                                                        </div>
                                                    </td>
                                                <td className="py-3">
                                                    <button 
                                                        className="btn btn-sm d-inline-flex align-items-center gap-2"
                                                        onClick={() => handleEditClick(item)}
                                                        style={{
                                                            background: 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
                                                            borderRadius: '8px',
                                                            padding: '0.5rem 1rem',
                                                            border: 'none',
                                                            color: 'white',
                                                            transition: 'all 0.3s ease',
                                                            fontSize: '0.85rem'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = 'none';
                                                        }}
                                                    >
                                                        <span className='pr-1'>                                                        <FaEdit size={14} style={{ marginTop: '-2px' }} />
                                                        </span>
                                                        <span>Edit</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Pagination */}
                        <div className="card-footer bg-white border-0 py-2 py-md-3" style={{ borderRadius: '0 0 15px 15px' }}>
                            <div className="footar_bottom">
                                <div className="text-center text-md-start">
                                    <span className="text-muted small">
                                        Showing {pageinationdata.startItem || 0}-{pageinationdata.endItem || 0} of {pageinationdata.total || 0} transactions
                                    </span>
                                </div>
                                <nav aria-label="Page navigation">
                                    <ul className="pagination pagination-sm mb-0 flex-wrap justify-content-center">
                                        <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link border-0 shadow-sm" 
                                                onClick={() => handlePageChange(1)}
                                                disabled={!pageinationdata.hasPrevPage}
                                                style={{ borderRadius: '8px', margin: '0 2px' }}
                                            >
                                                <span aria-hidden="true">&laquo;&laquo;</span>
                                            </button>
                                        </li>
                                        <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link border-0 shadow-sm" 
                                                onClick={() => handlePageChange(page - 1)}
                                                disabled={!pageinationdata.hasPrevPage}
                                                style={{ borderRadius: '8px', margin: '0 2px' }}
                                            >
                                                <span aria-hidden="true">&laquo;</span>
                                            </button>
                                        </li>
                                        
                                        {(() => {
                                            const totalPages = pageinationdata.totalPages || 0;
                                            const pagesPerGroup = 6;
                                            let startPage = Math.max(1, page - Math.floor(pagesPerGroup / 2));
                                            let endPage = Math.min(totalPages, startPage + pagesPerGroup - 1);
                                            
                                            if (endPage - startPage + 1 < pagesPerGroup) {
                                                startPage = Math.max(1, endPage - pagesPerGroup + 1);
                                            }
                                            
                                            const pageNumbers = [];
                                            for (let i = startPage; i <= endPage; i++) {
                                                pageNumbers.push(i);
                                            }
                                            
                                            return pageNumbers.map(pageNum => (
                                                <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>
                                                    <button 
                                                        className="page-link border-0 shadow-sm" 
                                                        onClick={() => handlePageChange(pageNum)}
                                                        style={{ 
                                                            borderRadius: '8px', 
                                                            margin: '0 2px',
                                                            background: page === pageNum ? 'linear-gradient(135deg, #4e73df 0%, #224abe 100%)' : 'white',
                                                            color: page === pageNum ? 'white' : 'inherit'
                                                        }}
                                                    >
                                                        {pageNum}
                                                    </button>
                                                </li>
                                            ));
                                        })()}
                                        
                                        <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link border-0 shadow-sm" 
                                                onClick={() => handlePageChange(page + 1)}
                                                disabled={!pageinationdata.hasNextPage}
                                                style={{ borderRadius: '8px', margin: '0 2px' }}
                                            >
                                                <span aria-hidden="true">&raquo;</span>
                                            </button>
                                        </li>
                                        <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
                                            <button 
                                                className="page-link border-0 shadow-sm" 
                                                onClick={() => handlePageChange(pageinationdata.totalPages || 1)}
                                                disabled={!pageinationdata.hasNextPage}
                                                style={{ borderRadius: '8px', margin: '0 2px' }}
                                            >
                                                <span aria-hidden="true">&raquo;&raquo;</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Modal */}
            <Modal
                isOpen={showModal}
                onRequestClose={handleCloseModal}
                contentLabel="Edit Transaction Modal"
                style={customStyles}
                className="modal-dialog modal-dialog-centered modal-lg m-0"
                overlayClassName="modal-overlay"
                ariaHideApp={false}
            >
                <div className="modal-content shadow border-0">
                    <div className="modal-header bg-primary text-white border-0">
                        <h5 className="modal-title">
                            <FaMoneyBillWave className="me-2" /> Edit Transaction
                        </h5>
                        <button type="button" className="btn-close btn bg-white" onClick={handleCloseModal}>
                            <IoMdClose />
                        </button>
                    </div>
                    <div className="modal-body p-4">
                        {selectedTransaction && (
                            <div className="user-info mb-4 p-3 bg-light rounded">
                                <div className="d-flex flex-column flex-md-row justify-content-between gap-2">
                                    <div className='overflow-wrap-anywhere_div'>
                                        <h5 className="mb-1">{selectedTransaction.userId?.name}</h5>
                                        <p className="text-muted mb-0">{selectedTransaction.userId?.email}</p>
                                    </div>
                                   
                                </div>
                            </div>
                        )}
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-4">
                                    <label htmlFor="balance" className="form-label fw-bold">Amount ($)</label>
                                    <div className="input-group input-group-lg">
                                        <span className="input-group-text">$</span>
                                        <input
                                            type="number"
                                            className="form-control form-control-lg"
                                            id="balance"
                                            name="balance"
                                            value={editData.balance}
                                            onChange={handleInputChange}
                                            placeholder="Enter amount"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 mb-4">
                                    <label htmlFor="expiryDate" className="form-label fw-bold">Expiry Date</label>
                                    <div className="input-group">
                                        <span className="input-group-text"><FaCalendarAlt /></span>
                                        <input
                                            type="date"
                                            className="form-control form-control-lg"
                                            id="expiryDate"
                                            name="expiryDate"
                                            value={editData.expiryDate}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <small className="text-muted">
                                        <FaInfoCircle className="me-1" />
                                        Optional: Set an expiration date for these funds
                                    </small>
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="transactionType" className="form-label fw-bold">Transaction Type</label>
                                <div className="d-flex flex-column flex-md-row gap-2">
                                    <div className="form-check form-check-inline flex-fill">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="transactionType"
                                            id="typeCredit"
                                            value="credit"
                                            checked={editData.transactionType === 'credit'}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label w-100" htmlFor="typeCredit">
                                            <span className="badge bg-success p-2 px-3 text-white d-block text-center">Credit (Add)</span>
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline flex-fill">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="transactionType"
                                            id="typeDebit"
                                            value="debit"
                                            checked={editData.transactionType === 'debit'}
                                            onChange={handleInputChange}
                                        />
                                        <label className="form-check-label w-100" htmlFor="typeDebit">
                                            <span className="badge bg-danger p-2 px-3 text-white d-block text-center">Debit (Withdraw)</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="message" className="form-label fw-bold">Description</label>
                                <textarea
                                    className="form-control"
                                    id="message"
                                    name="message"
                                    value={editData.message}
                                    onChange={handleInputChange}
                                    placeholder="Enter transaction details"
                                    rows="3"
                                    required
                                ></textarea>
                                <small className="text-muted">
                                    <FaInfoCircle className="me-1" />
                                    Briefly describe the purpose of this transaction
                                </small>
                            </div>

                            <div className="d-grid gap-2 mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-success btn-lg"
                                >
                                    <FaMoneyBillWave className="me-2" />
                                    {editData.transactionType === 'credit' ? 'Update Credit' : 'Update Debit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>

            <style jsx>{`
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                }
                
                .modal-content {
                    max-height: 90vh;
                    overflow-y: auto;
                }
            `}</style>
        </div>
    )
}

export default Viewwallet
